export default {
  name: 'Link ID',
  edit: {
    form: 'applet-id',
    label: 'Change Link ID',
    handler: value => value,
  },
};
